import { Link, useLocation } from "react-router-dom";

const COPY = {
  en: {
    title: "Page not found",
    message: "The requested page could not be found.",
    home: "Return to homepage",
  },
  nl: {
    title: "Pagina niet gevonden",
    message: "De opgevraagde pagina kon niet worden gevonden.",
    home: "Terug naar de homepage",
  },
  de: {
    title: "Seite nicht gefunden",
    message: "Die angeforderte Seite konnte nicht gefunden werden.",
    home: "Zur Startseite",
  },
};

export default function NotFound() {
  const { pathname } = useLocation();
  const requestedLanguage = pathname.split("/").filter(Boolean)[0];
  const language = COPY[requestedLanguage] ? requestedLanguage : "en";
  const content = COPY[language];

  return (
    <main className="container py-5 text-center" id="page">
      <h1>{content.title}</h1>
      <p>{content.message}</p>
      <Link className="btn black-btn mt-3" to={`/${language}/`}>
        {content.home}
      </Link>
    </main>
  );
}
